<ngb-toast *ngFor="let toast of toastService.toasts"
           [class]="toast.className"
           [autohide]="true"
           [delay]="toast.delay || 10000"
           (hide)="toastService.remove(toast)">

  <ng-template [ngIf]="isTemplate(toast)" [ngIfElse]="text">
    <ng-template [ngTemplateOutlet]="toast.textOrTpl"></ng-template>
  </ng-template>

  <ng-template #text>
    <ng-template [ngIf]="toast.iconClassName">
      <i [class]="toast.iconClassName"></i>
      &nbsp;
    </ng-template>
    {{toast.textOrTpl}}
  </ng-template>
</ngb-toast>
